
function RecentArticle({ image, PostHeading, date, slug }) {
    return (
        <article className="post">
            <figure className="post-thumb"><img style={{ marginTop: `9px` }} src={image} alt='' /></figure>
            <div className="text"><a href={`/posts/${slug}`}>{PostHeading}</a>
            </div>
            <div className="post-info">{date}</div>
        </article>
    )
}

export default RecentArticle
